import { Component } from '@verndale/core';
import { KEYS } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.timer = null;
    this.dom = {
      $statisticCards: this.el._$$('.statistic-card__item')
    };

    this.cardClass = '.statistic-card__item';
    this.activeCardClass = 'statistic-card__item--active';

    if (this.dom.$statisticCards.length > 0) {
      this.dom.$statisticCards[0].classList.add(this.activeCardClass);
      this.dom.$statisticCards.forEach((card, idx) => {
        card._$('.statistic-card__number').innerText = `0${idx + 1}`;
      });
    }
  }

  addListeners() {
    this.el._on('click', this.handleUserInput.bind(this));
    this.el._on('mousemove', this.handleUserInput.bind(this));
    this.el._on('keydown', this.handleUserInput.bind(this));
    this.el._on('focusin', this.handleFocusIn.bind(this));
  }

  handleFocusIn(e) {
    if (!e.target.closest(this.cardClass)) return;
    this.addActiveClass(e.target);
  }

  handleUserInput(e) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (!e.target.closest(this.cardClass) || e.target.classList.contains(this.activeCardClass)) return;

      const card = e.target.closest(this.cardClass);
      const addActiveClass = e.type === 'mousemove' || e.type === 'click' || (e.keyCode === KEYS.ENTER || e.keyCode === KEYS.SPACE);

      if (addActiveClass) this.addActiveClass(card);
    }, 250);
  }

  addActiveClass(card) {
    this.removeActiveClasses();
    card.classList.add(this.activeCardClass);
    if (card !== document.activeElement) card.focus();
  }

  removeActiveClasses() {
    this.dom.$statisticCards.forEach(card => card.classList.remove(this.activeCardClass));
  }
}

export default Module;
